import React from 'react';
import DatasourceSection from './DataSourceSection.lazy.jsx';
import ChartSettings from '../chart/ChartSettings.jsx';

function DatasourceSettings({
  widgetId,
  datasource_props = {},
  ChartSettingsComponent = ChartSettings,
  chart_settings_props
}){
    return (
        <>
            <DatasourceSection widgetId={widgetId} />
            {ChartSettingsComponent && <>
                <hr />
                <ChartSettingsComponent 
                    {...chart_settings_props} 
                    datasource_props={datasource_props}
                    useDataSourceValues={true} widgetId={widgetId} />
            </>}
        </>
    );
}

export default DatasourceSettings;
